import React, { useState } from 'react';
import {
	MDBCard as Card,
	MDBCardTitle as CardTitle,
	MDBIcon as Icon,
	MDBMask
} from 'mdbreact';

const Product = ({ title, description, img }) => {
	const [flipped, setFlipped] = useState(false);

	const handleFlipping = () => {
		setFlipped(!flipped);
	};

	return (
		<div className='text-center flip-card w-100'>
			<div
				className='flip-card-inner'
				style={{ transform: `rotateY(${flipped ? '180' : '0'}deg)` }}>
				<Card
					style={{
						backgroundSize: 'cover',
						backgroundImage: `url('${img}')`
					}}
					className='text-center flip-card-back'>
					<MDBMask pattern={5} className='h-100'>
						<div className='text-white text-center d-flex align-items-center rgba-black-strong py-5 px-4 rounded h-100'>
							<div>
								<CardTitle tag='h2' className='pt-2 font-weight-bold'>
									<strong>{title}</strong>
								</CardTitle>
								<hr className='hr-light my-4' />
								<p>{description}</p>
								<a
									href='#!'
									className='white-text d-flex justify-content-center'
									onClick={handleFlipping}>
									<h5>
										<Icon icon='angle-double-left' className='ml-2' /> Back
									</h5>
								</a>
							</div>
						</div>
					</MDBMask>
				</Card>
				<Card
					style={{
						backgroundSize: 'cover',
						backgroundImage: `url('${img}')`
					}}
					className='flip-card-front'>
					<div className='text-white text-center d-flex align-items-center rgba-black-strong py-5 px-4 rounded h-100'>
						<div className='mx-auto'>
							<CardTitle tag='h1' className='pt-2 font-weight-bold'>
								<strong>{title}</strong>
							</CardTitle>
							<a
								href='#!'
								className='white-text d-flex justify-content-end'
								onClick={handleFlipping}>
								<h5>
									Read more
									<Icon icon='angle-double-right' className='ml-2' />
								</h5>
							</a>
						</div>
					</div>
				</Card>
			</div>
		</div>
	);
};

export default Product;
